import Select from '~/components/Select';
import TextInput from '~/components/TextInput';
import Toggle from '~/components/Toggle.jsx';
import { countCodes } from '~/lib/CouponHelpers';

const limitOptions = {
    unlimited: 'Unlimited uses',
    onceperclient: 'Once per client',
    total: 'Total number of uses',
};

const REQUIRES_NUMBER_INPUT = ['total'];

const CouponLimitsInput = ({ value, onChange, codes }) => {
    const numCodes = countCodes(codes);
    const showApplyPerCode = numCodes > 1 && value?.type === 'total';

    return (
        <div>
            <Select
                options={limitOptions}
                onChange={newValue => onChange({ ...value, type: newValue })}
                value={value?.type}
            />
            {REQUIRES_NUMBER_INPUT.includes(value?.type) && (
                <TextInput
                    onChange={newValue =>
                        onChange({ ...value, count: newValue })
                    }
                    value={value?.count || ''}
                    label="Total Number of Uses"
                    placeholder="1"
                    min="1"
                    type="number"
                    autoFocus={!value?.count}
                    className="mt-4 max-w-48"
                />
            )}
            {showApplyPerCode && (
                <label className="flex items-center gap-x-4 mt-4">
                    <Toggle
                        enabled={value?.applyPerCode || false}
                        setEnabled={(newValue) => {
                            onChange({ ...value, applyPerCode: newValue })
                        }}
                    />
                    <div>
                        Apply per code
                        <div className="text-sm text-gray-500">
                            {!!value?.applyPerCode && (
                                <span>Each code can be used {value?.count} time{value?.count > 1 ? 's' : ''}</span>
                            )}
                            {!value?.applyPerCode && (
                                <span>
                                    This can be used a total of {value?.count} time{value?.count > 1 ? 's' : ''} between all codes
                                </span>
                            )}
                        </div>

                    </div>
                </label>
            )}
        </div>
    );
};

export default CouponLimitsInput;
